<template>
  <section>
    <form action v-on:submit.prevent="createRemitent">
      <div class="modal-card">
        <header class="modal-card-head">
          <p>Crear Remitentefd</p>
        </header>
        <section class="modal-card-body">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <b-field label="Nombre del remitente" :label-position="'on-border'">
            <b-input v-model="remitent.name" required></b-input>
          </b-field>
          <b-field label="Tipo de remitente" :label-position="'on-border'">
            <b-select
              placeholder="Seleccionar tipo  de remitente"
              v-model="remitent.type_remitent_id"
              expanded
              required
            >
              <option
                v-for="option in listTypeRemitent"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">
            Cerrar
          </button>
          <button class="button is-primary" type="submit">Guardar</button>
        </footer>
      </div>
    </form>
  </section>
</template>
<script>

import {RemitentService} from "../../../services/models/remitent"
import {TypeRemitentService} from "../../../services/models/type_remitent"

export default {
  props: ["chargeListRemitent"],
  data() {
    return {
      listTypeRemitent: [],
      remitent: {
        name: "",
        type_remitent_id: 1,
      },
      isLoading: false,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      const {data} = await TypeRemitentService.getAll();
      this.listTypeRemitent = data.data;
      this.isLoading = false;
    },
    async createRemitent() {
      this.isLoading = true;
      await RemitentService.create(this.remitent);
      this.isLoading = false;
      this.$buefy.notification.open({
        message: "Remitente Creado!",
        type: "is-success",
      });
      this.chargeListRemitent();
      this.$parent.close();
    },
  },
};
</script>